<div class="promo-t5-page">
    <!-- =========================================
       ENCABEZADO
  ========================================== -->
    <section class="promo-t5-header">
        <span class="promo-t5-eyebrow">
            PROMOCIÓN
        </span>
        <h1 class="promo-t5-title">
            {{ promo }}
        </h1>
        <p class="promo-t5-subtitle" *ngIf="stepOne">
            Elige el producto que deseas comprar.
        </p>
        <p class="promo-t5-subtitle" *ngIf="stepTwo">
            Ahora elige el producto que quieres recibir de regalo.
        </p>
    </section>
    <!-- =========================================
       PASO 1
  ========================================== -->
    <section class="promo-t5-step" *ngIf="stepOne">
        <div class="promo-t5-step-header">
            <div>
                <span class="promo-t5-step-eyebrow">
                    PASO 1 DE 2
                </span>
                <h2>
                    Elige tu producto
                </h2>
                <p>
                    Selecciona el producto que deseas comprar.
                </p>
            </div>
        </div>
        <div class="promo-t5-grid" *ngIf="products.length > 0">
            <article class="promo-t5-card" [class.selected]="product.selected" *ngFor="let product of products"
                (click)="selectedProduct(product)">
                <div class="promo-t5-image">
                    <img [src]="product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.productoAgrupador || product.producto">
                </div>
                <div class="promo-t5-card-content">
                    <div class="promo-t5-product-info">
                        <h3>
                            {{ product.producto }}
                        </h3>
                        <p class="promo-t5-price">
                            {{ product.precioNormal | currency:'USD':'symbol':'1.0-0' }}
                        </p>
                    </div>
                    <div class="promo-t5-check" *ngIf="product.selected">
                        <mat-icon>
                            check_circle
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>
        <!-- BOTÓN PASO 1 -->
        <div class="promo-t5-action">
            <button class="promo-t5-button" mat-raised-button type="button" (click)="continuar()"
                [disabled]="selectedProductData === null">
                CONTINUAR
            </button>
        </div>
    </section>
    <!-- =========================================
       PASO 2
  ========================================== -->
    <section class="promo-t5-step" *ngIf="stepTwo">
        <div class="promo-t5-step-header">
            <div>
                <span class="promo-t5-step-eyebrow">
                    PASO 2 DE 2
                </span>
                <h2>
                    Elige tu regalo
                </h2>
                <p>
                    Selecciona el producto que recibirás gratis.
                </p>
            </div>
        </div>
        <div class="promo-t5-grid" *ngIf="gifts.length > 0">
            <article class="promo-t5-card" [class.selected]="gift.selected" *ngFor="let gift of gifts"
                (click)="selectedProductGift(gift)">
                <div class="promo-t5-image">
                    <img [src]="gift.urlFoto" [defaultImage]="defImgProd"
                        [alt]="gift.productoAgrupador || gift.producto">
                </div>
                <div class="promo-t5-card-content">
                    <div class="promo-t5-product-info">
                        <h3>
                            {{ gift.producto }}
                        </h3>
                        <span class="promo-t5-gift-label">
                            REGALO
                        </span>
                    </div>
                    <div class="promo-t5-check" *ngIf="gift.selected">
                        <mat-icon>
                            check_circle
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>
        <!-- BOTÓN PASO 2 -->
        <div class="promo-t5-action">
            <button class="promo-t5-button" mat-raised-button type="button" (click)="finalizar()"
                [disabled]="selectedProductData === null || btnDisabled">
                SELECCIONAR
            </button>
        </div>
    </section>
</div>